module.exports = __webpack_public_path__ + "img/message.11c0d8a9.png";